/**
 * The renderer's words for a settings page (`kind: settings`, docs/ui-components.md §7.2): the
 * button that changes a section, and what it says while nothing is set. Spread into the catalogue.
 */
export const SETTINGS_EN = {
    'settings.change': 'Change',
    'settings.change.named': 'Change: {section}',
    'settings.empty': 'Nothing is set yet.',
    'settings.malformed': 'These settings arrived in a shape this page cannot read.',
};
export const SETTINGS_AR = {
    'settings.change': 'تغيير',
    'settings.change.named': 'تغيير: {section}',
    'settings.empty': 'لم يُضبط شيء بعد.',
    'settings.malformed': 'وصلت هذه الإعدادات بشكل لا تقرؤه هذه الصفحة.',
};
//# sourceMappingURL=i18n-settings.js.map